module.exports = __webpack_public_path__ + "static/media/fondo-prueba3.396f9077.jpg";